import { computed } from 'vue';
import { NEWEST_BACKEND } from "@/remotes";
import { useDataFormStore } from "@/stores/form";
import { useDataFormStoreApi } from "@/stores/formSave";
import { Printer, Plus, Files } from "@element-plus/icons-vue";

const allowedDomains = [
  "https://xn----stbeziy.xn--p1ai",
  "https://website-tk-luch-rf-test.int.otr-it.net"
];

export default {
  props: {
    ruleFormRef: Object,
    alertOfApplicationSubmission: Object,
  },

  setup(props) {
    const dataForm = useDataFormStore();

    const dataFormApi = useDataFormStoreApi();
    function parseDate(date) {
      return date < 10 ? `0${date}` : date;
    }

    const isStorage = computed(() => !props.alertOfApplicationSubmission.pickupDate);

    const hasEp = computed(() => !!props.alertOfApplicationSubmission?.customer?.inn);

    const storageAddress = computed(() => {
      const city = dataForm.sender.cityFrom;
      const address = dataForm.sender.officeFrom?.address;
      if (!city || !address) return '';
      return `г. ${city}: ${address}`;
    });

    const pickUpAddress = computed(() => {
      const pickup = dataForm.applicationCargoPickup;
      return pickup.adressDetailRequired
        ? pickup.addressCargoPickupNotice
        : pickup.addressCargoPickup;
    });

    const pickUpDateFormatted = computed(() =>
      props.alertOfApplicationSubmission.pickupDate || ''
    );

    const pickUpTimeRange = computed(() => {
      const start = props.alertOfApplicationSubmission.cargoStartTimePickup;
      const end = props.alertOfApplicationSubmission.cargoEndTimePickup;
      if (!start || !end) return '';
      return `с ${start} до ${end}`;
    });

    const typeText = computed(() =>
      isStorage.value ? '' : 'Курьер позвонит вам за час до прибытия'
    );

    function downloadPackage() {
      const parentOrigin = allowedDomains.find(domain => document.referrer.startsWith(domain));
      if (parentOrigin) {
        window.parent.postMessage({ action: "package" }, parentOrigin)
      }
    }

    function downloadLogisticsForwardingOrder(id, number) {
      (async function () {
        try {
          const { data } = await NEWEST_BACKEND.get(
            `/public/logistics-forwarding-order-zip/${id}`,
            { responseType: 'arraybuffer' },

          );

          const parentOrigin = allowedDomains.find(domain => document.referrer.startsWith(domain));
          if (parentOrigin) {
            window.parent.postMessage({ action: "packagelogistic", id: number, data: data  }, parentOrigin, [data])
          }
        } catch (e) {
          console.log(e);
        }
      })();

    }

    function rollBack() {
      dataForm.isOrderDone = false
      if (document.querySelector(".calculator__title")) {
        if(dataForm.applicationCargoPickup.isCargoPickup){
          document.querySelector(".calculator__title").innerHTML = "Оформление заявки на забор груза"
        } else {
          document.querySelector(".calculator__title").innerHTML = "Оформление экспедиторской расписки перед отправкой"
        }
      }
    }

    const isXMLisAllowToShow = computed(() => dataForm.other.payers.length === 1);

    return {
      parseDate,
      Printer,
      Plus,
      isXMLisAllowToShow,
      Files,
      dataForm,
      dataFormApi,
      rollBack,
      downloadPackage,
      downloadLogisticsForwardingOrder,
      isStorage,
      hasEp,
      storageAddress,
      pickUpAddress,
      pickUpDateFormatted,
      pickUpTimeRange,
      typeText,
    };
  },
};
